module.exports = __webpack_public_path__ + "static/par-logo-f2391a42daa727d2e3e6782da879f962.png";